import { getLoginParams } from '@collab/libs/auth/oauth2';

import { volvoIdAuthCallback } from 'libs/auth/useApimExchange';
import { AddedApimState } from 'libs/auth/volvoIdAuthTypes';

import { getVolvoIdApimLoginUrl } from './apim.api';

export const redirectLogin = async (
  apiId: string,
  postLoginRedirectUrl: string,
): Promise<void> => {
  const state: AddedApimState = {
    apiName: apiId,
    postLoginRedirectUrl,
  };

  const params = await getLoginParams({
    redirectUrl: volvoIdAuthCallback,
    state,
  });

  window.location.href = await getVolvoIdApimLoginUrl(apiId, params);
};
